




















import {Component, Prop, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/dialog/DialogMixin';

@Component({
    inheritAttrs: false,
})
export default class CAlertDialog extends Mixins(DialogMixin) {}
